import React, { useState, useEffect } from 'react';
import './UnderConstruction.css';
import Header from '../components/menu/header';

const UnderConstruction = ({ 
  pageName = "Pagina",
  testo = null, 
  logoUrl = null,
  logoAlt = "Logo"
}) => {
  const [progress, setProgress] = useState(0);

  // Animazione del progresso
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 75) return 0;
        return prev + 1;
      });
    }, 40);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="construction-page">
      <Header />
      <div className="construction-container">
        <div className="construction-card">
          
          {/* Icona/Logo animato */}
          <div className="construction-icon-container">
            <div className="construction-icon">
              {logoUrl ? (
                <img 
                  src={logoUrl} 
                  alt={logoAlt}
                  className="construction-logo"
                />
              ) : (
                // Fallback: icona generica se non c'è logo
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              )}
            </div>
          </div>

          {/* Contenuto principale */}
          <div className="construction-content">
            <h1 className="construction-title">
              {pageName} in Costruzione
            </h1>
            
            {testo ? (
              <p className="construction-subtitle">
                {testo}
              </p>
            ):(
              <p className="construction-subtitle">
                Stiamo lavorando duramente per portarti una nuova esperienza. 
                Questa pagina sarà disponibile molto presto con funzionalità ancora più avanzate!
              </p>
            )}
            

            {/* Barra di progresso animata */}
            <div className="construction-progress-container">
              <div className="construction-progress-label">
                <span>Progresso Ideazione</span>
                <span>{Math.min(progress, 75)}%</span>
              </div>
              <div className="construction-progress-bar">
                <div 
                  className="construction-progress-fill"
                  style={{ width: `${Math.min(progress, 75)}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;

/* Aggiunta CSS per il logo */